import script from "./index.vue?vue&type=script&lang=ts&name=Footer&setup=true"
export * from "./index.vue?vue&type=script&lang=ts&name=Footer&setup=true"

import "./index.vue?vue&type=style&index=0&id=6321460c&scoped=true&lang=css"

import exportComponent from "/Users/niming/Documents/vue-mooc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6321460c"]])

export default __exports__